import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Typography,
  IconButton,
  Button,
  Select,
  MenuItem,
  TextField,
} from "@mui/material";
import { getData, postData } from "../../../ServerRequest";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ManualNestedCollection from "./ManualNestedCollection";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export default function ManualCollection({
  setManualCollection,
  setSearchCollectionTagIds,
  setManualNestedCollection,
  setShowDefineCollection,
  handleShowCollectionSection,
  mainCollectionId,
  isManualCollectionSaved, // <-- changed from isCollectionSaved
  collectionCondition,
  setCollectionCondition, // <-- add prop
  setManualMinQuantity, // <-- add this prop
}) {
  const searchParams = new URLSearchParams(window.location.search);
  const collectionId = searchParams.get("collection_id");
  const [loading, setLoading] = useState(true);
  const [tagsData, setTagsData] = useState([]);
  const [familyData, setFamilyData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [minQuantity, setMinQuantity] = useState("");
  const [filteredTagCategories, setFilteredTagCategories] = useState([]);
  const [filteredProductTags, setFilteredProductTags] = useState([]);
  const [collectionCombData, setCollectionCombData] = useState([]);
  const [manualProperties, setManualProperties] = useState([
    {
      id: 1,
      manualTagFamily: "",
      manualTagCategory: "",
      manualProductTag: "",
      manualMinQuantity: "",
      productCount: 0, // Initialize productCount
    },
  ]);
  const [showNestedCollection, setShowNestedCollection] = useState(false);

  useEffect(() => {
    async function fetchData() {
      try {
        let masterRes = await getData("/api/product/acc_tag_master");
        console.log(masterRes);
        let master_data = masterRes["data"]["live_tags"];
        if (master_data) {
          console.log(master_data);
          setTagsData(master_data);
        } else {
          console.error("Error fetching tag master data:", masterRes.message);
        }

        let familyRes = await getData("/api/product/acc_tag_family");
        console.log(familyRes);
        let family_data = familyRes["data"]["tag_families"];
        if (family_data) {
          console.log(family_data);
          setFamilyData(family_data);
        } else {
          console.error("Error fetching tags family data:", familyRes.message);
        }

        let categoryRes = await getData("/api/product/acc_tag_category");
        console.log(categoryRes);
        let category_data = categoryRes["data"]["tag_categories"];
        if (category_data) {
          console.log(category_data);
          setCategoryData(category_data);
        } else {
          console.error(
            "Error fetching tags category data:",
            categoryRes.message
          );
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
    console.log("mainCollectionId:", mainCollectionId);
  }, [collectionId, mainCollectionId, collectionCombData]);

  useEffect(() => {
    manualProperties.forEach((property, index) => {
      // Filter Tag Categories based on selected Tag Family
      const filteredCategories = categoryData.filter(
        (category) =>
          !property.manualTagFamily ||
          category.family === property.manualTagFamily
      );
      setFilteredTagCategories(filteredCategories);

      // Filter Product Tags based on selected Tag Family, Tag Category, and Min Quantity
      const filteredTags = tagsData.filter(
        ({ family, category, quantityId }) =>
          (!property.manualTagFamily || family === property.manualTagFamily) &&
          (!property.manualTagCategory ||
            category === property.manualTagCategory) &&
          (!property.manualMinQuantity ||
            quantityId >= property.manualMinQuantity)
      );
      setFilteredProductTags(filteredTags);

      // Debugging logs
      //console.log(`Property ${index + 1} - Selected Tag Family:`, property.manualTagFamily);
      //console.log(`Property ${index + 1} - Filtered Categories:`, filteredCategories);
      //console.log(`Property ${index + 1} - Selected Tag Category:`, property.manualTagCategory);
      //console.log(`Property ${index + 1} - Min Quantity:`, property.manualMinQuantity);
      //console.log(`Property ${index + 1} - Filtered Product Tags:`, filteredTags);
    });
  }, [tagsData, categoryData, manualProperties]);


  const fetchCollectionCombData = async () => {
    setLoading(true);
    console.log("Fetching collection combinations...");
    console.log("Collection ", manualProperties);
    const combTagsIds = [];
    manualProperties.forEach((property) => {
      if (property.manualProductTag && property.manualProductTag !== "") {
        combTagsIds.push(property.manualProductTag);
      }
    });
    const requestData = {
      tag_ids: combTagsIds,
      min_quantity: minQuantity,
    };
    const collectionPreCombinationReqData = await postData(
      `/api/product/pre-generate-collection-combinations`,
      requestData
    );
    // console.log("Collection Combination Data:", collectionCombinationReqData);
    if (collectionPreCombinationReqData["code"] !== 200) {
      console.error("Error fetching collection combinations:", collectionPreCombinationReqData.message);
    }
    setLoading(false);
    setCollectionCombData(collectionPreCombinationReqData["data"]["combinations"] || []);
  };

  const handleAddManualProperty = () => {
    setManualProperties([
      ...manualProperties,
      {
        id: manualProperties.length + 1,
        manualTagFamily: "",
        manualTagCategory: "",
        manualProductTag: "",
        manualMinQuantity: "",
      },
    ]);
    setCollectionCombData([]); // Reset collection combinations when adding a new property
  };

  const handleCreateCollection = () => {
    const combinedTags = manualProperties
      .map((property) => {
        const filteredProductTag = tagsData.find(
          ({ id }) => id === property.manualProductTag
        );
        return filteredProductTag
          ? {
            id: filteredProductTag.id,
            product_tag: filteredProductTag.product_tag,
          }
          : null;
      })
      .filter((tag) => tag !== null); // Filter out null values

    const combinedTagIds = combinedTags.map((tag) => tag.id);

    console.log("Final Combined Tags Before Filtering:", combinedTags);

    // Extract only valid product_tag values and filter out invalid ones
    const validTags = combinedTags
      .map((tag) => tag.product_tag?.trim())
      .filter((tag) => tag && tag !== "");
    const validTagIds = combinedTagIds.filter((id) => id && id !== "");

    console.log("Filtered Valid Tags:", validTags);
    setSearchCollectionTagIds(validTagIds);
    setManualCollection(combinedTags); // Set the combined tags directly
    if (setManualMinQuantity) setManualMinQuantity(minQuantity); // Pass min qty up
    setShowDefineCollection(true);
  };

  const handleManualPropertyChange = (id, field, value) => {
    // Update the manualProperties state
    setCollectionCombData([]);
    setManualProperties((prev) =>
      prev.map((property) =>
        property.id === id ? { ...property, [field]: value } : property
      )
    );

    // If the field is manualProductTag, update the manualCollection
    if (field === "manualProductTag") {
      setManualCollection((prev) => {
        // Find the selected tag in tagsData
        const selectedTag = tagsData.find((tag) => tag.id === value);

        if (!selectedTag) {
          return prev; // If no tag is found, return the previous state
        }
        // If the tag is already in manualProperties, remove it
        // Remove any existing entry for the current property
        const updatedCollection = prev.filter(
          (tag) =>
            !manualProperties.some(
              (property) =>
                property.id === id && property.manualProductTag === tag.id
            )
        );

        // Fetch product count for the selected tag and update property
        if (selectedTag) {
          getData(`/api/product/get-tag-product-count?tag_id=${selectedTag.id}`)
            .then((res) => {
              const count = res?.data?.product_count || 0;
              // Update the productCount in manualProperties
              setManualProperties((prevProps) =>
                prevProps.map((prop) =>
                  prop.id === id
                    ? { ...prop, productCount: count }
                    : prop
                )
              );

            })
            .catch(() => {
              setManualProperties((prevProps) =>
                prevProps.map((prop) =>
                  prop.id === id
                    ? { ...prop, productCount: 0 }
                    : prop
                )
              );
            });

        }

        // Add the new selected tag
        updatedCollection.push({
          id: selectedTag.id,
          product_tag: selectedTag.product_tag.trim(),
        });
        return updatedCollection;
      });
    }
  };

  const handleRemoveManualProperty = (id) => {
    // Remove the property with the given id from manualProperties
    setManualProperties((prev) => prev.filter((property) => property.id !== id));
    fetchCollectionCombData(); // Refresh combinations after removal
  };

  const togglenestedTags = () => {
    setShowNestedCollection((prev) => !prev); // Toggle nested collection visibility
  };


  return (
    <Box sx={{ width: "100%" }}>
      {/* Create Manual Tags collection */}
      <Box sx={{ mt: 2 }}>
        {/* Manual Tags Dropdown */}
        <Accordion
          sx={{
            mt: 1,
            backgroundColor: "white",
            boxShadow: 0,
            border: "1px solid #BCC1CA",
          }}
        >
          <AccordionSummary
            variant="h7"
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              fontFamily: "Inter",
              fontWeight: 700,
              fontSize: 16,
              height: 53,
            }}
            expandIcon={<ExpandMoreIcon />}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {isManualCollectionSaved ? (
                <CheckCircleIcon
                  sx={{
                    mr: 2,
                    color: "#565E6D",
                  }}
                />
              ) : (
                <RadioButtonUncheckedIcon
                  sx={{ mr: 2 }}
                />
              )}
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                Create collection by manually defining tags
              </span>
            </Box>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              padding: 7,
              pt: 2,
              pb: 4.5,
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: 2,
              }}
            >
              <Box sx={{ display: "flex", flexDirection: "column", gap: 0 }}>
                <Typography
                  variant="body1"
                  sx={{
                    color: "#424956",
                    fontFamily: "Inter",
                    fontWeight: 700,
                    fontSize: 14,
                  }}
                >
                  Min quantity/ tag (in Mtr)
                </Typography>
                <TextField
                  sx={{
                    width: 191,
                    "& .MuiOutlinedInput-root": {
                      height: "35px",
                      borderRadius: "0px",
                      backgroundColor: "#fff",
                    },
                  }}
                  value={minQuantity}
                  onChange={(e) => setMinQuantity(e.target.value)}
                />
              </Box>
              {/* AND/OR Condition Select */}
              <Box sx={{ minWidth: 100 }}>
                {/* <Typography
                  variant="body1"
                  sx={{
                    color: "#424956",
                    fontFamily: "Inter",
                    fontWeight: 700,
                    fontSize: 14,
                  }}
                >
                  Condition
                </Typography> */}
                {/* <Select
                  value={collectionCondition || "OR"}
                  onChange={(e) => setCollectionCondition(e.target.value)}
                  sx={{
                    width: 100,
                    height: "35px",
                    borderRadius: "0px",
                    backgroundColor: "#F3F4F6",
                  }}
                  variant="outlined"
                >
                  <MenuItem value="OR">OR</MenuItem>
                  <MenuItem value="AND">AND</MenuItem>
                </Select> */}
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
                borderBottom: "1px solid #BCC1CA",
              }}
            >
              <Typography
                variant="body1"
                sx={{ fontFamily: "Inter", fontWeight: "700", fontSize: 16 }}
              >
                Select main collection tags
              </Typography>

              {manualProperties.map((property, index) => (
                <Box key={property.id}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      gap: 6,
                      mb: 2,
                      mt: 1,
                      alignItems: "flex-end",
                    }}
                  >
                    <Box>
                      <Typography
                        sx={{
                          color: "#424956",
                          fontFamily: "Inter",
                          fontWeight: 700,
                          fontSize: 14,
                        }}
                      >
                        Tag Family
                      </Typography>
                      <Select
                        value={property.manualTagFamily}
                        onChange={(e) =>
                          handleManualPropertyChange(
                            property.id,
                            "manualTagFamily",
                            e.target.value
                          )
                        }
                        sx={{
                          width: 191,
                          height: "35px",
                          borderRadius: "0px",
                          backgroundColor: "#fff",
                        }}
                        variant="outlined"
                      >
                        {familyData.map((family) => (
                          <MenuItem key={family.id} value={family.id}>
                            {family.tag_family}
                          </MenuItem>
                        ))}
                      </Select>
                    </Box>
                    <Box>
                      <Typography
                        sx={{
                          color: "#424956",
                          fontFamily: "Inter",
                          fontWeight: 700,
                          fontSize: 14,
                        }}
                      >
                        Tag Category
                      </Typography>
                      <Select
                        value={property.manualTagCategory}
                        onChange={(e) =>
                          handleManualPropertyChange(
                            property.id,
                            "manualTagCategory",
                            e.target.value
                          )
                        }
                        sx={{
                          width: 191,
                          height: "35px",
                          borderRadius: "0px",
                          backgroundColor: "#fff",
                        }}
                        variant="outlined"
                      >
                        {categoryData
                          .filter(
                            (category) =>
                              !property.manualTagFamily ||
                              category.tag_family === property.manualTagFamily
                          )
                          .map((category) => (
                            <MenuItem key={category.id} value={category.id}>
                              {category.category}
                            </MenuItem>
                          ))}
                      </Select>
                    </Box>
                    <Box>
                      <Typography
                        sx={{
                          color: "#424956",
                          fontFamily: "Inter",
                          fontWeight: 700,
                          fontSize: 14,
                        }}
                      >
                        Product Tag
                      </Typography>
                      <Select
                        value={property.manualProductTag}
                        onChange={async (e) => {
                          await handleManualPropertyChange(
                            property.id,
                            "manualProductTag",
                            e.target.value
                          );
                          fetchCollectionCombData();
                        }}
                        sx={{
                          width: 191,
                          height: "35px",
                          borderRadius: "0px",
                          backgroundColor: "#fff",
                        }}
                        variant="outlined"
                      >
                        {tagsData
                          .filter(
                            (tag) =>
                              !property.manualTagCategory ||
                              tag.tag_category === property.manualTagCategory
                          )
                          .map((tag) => (
                            <MenuItem key={tag.id} value={tag.id}>
                              {tag.product_tag}
                            </MenuItem>
                          ))}
                      </Select>
                    </Box>
                    <Box>
                      <Typography
                        sx={{
                          color: "#424956",
                          fontFamily: "Inter",
                          fontWeight: 700,
                          fontSize: 14,
                        }}
                      >
                        Product Count
                      </Typography>
                      <label
                        sx={{
                          width: 191,
                          height: "35px",
                          borderRadius: "0px",
                          backgroundColor: "#fff",
                          padding: "0 8px",
                        }}
                        variant="outlined"
                      >
                        {property.productCount}
                      </label>

                    </Box>
                    <Box>
                      <IconButton
                        onClick={() => handleRemoveManualProperty(property.id)}
                        style={{
                          height: "35px",
                          borderRadius: "0px",
                          color: "#000",
                        }}
                      >
                        <DeleteOutlinedIcon
                          style={{ color: "black", width: "20px", height: "20px" }}
                        />
                      </IconButton>

                    </Box>
                  </Box>
                </Box>
              ))}

              {/* Add another property button outside the loop */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 6,
                  mb: 4,
                  mt: 2,
                }}
              >
                <Button
                  startIcon={<AddCircleOutlineIcon />}
                  onClick={handleAddManualProperty}
                  sx={{
                    backgroundColor: "white",
                    color: "black",
                    textTransform: "none",
                    border: "1px solid #BCC1CA",
                    borderRadius: "0px",
                    height: "30px",
                    width: 191,
                    boxShadow: 0,
                  }}
                >
                  Add another property
                </Button>
              </Box>
            </Box>
            {/* Create collection Button */}
            <div style={{ textAlign: "start", marginTop: "15px" }}>
              <Button
                sx={{
                  width: "307px",
                  height: "44px",
                  backgroundColor: "#565E6D",
                  color: "#fff",
                  "&:hover": { backgroundColor: "#546e7a" },
                  borderRadius: "0px",
                }}
                onClick={fetchCollectionCombData} // Fetch collection combinations
              >
                Preview Combinations
              </Button>
            </div>
            <Box
              sx={{
                border: "1px solid #F4F3F6",
                '& div[class*="MUIDataTableToolbar"]': { display: "none" },
                mb: 2,
                mt: 2,
                background: "#fff",
                borderRadius: "0px",
                overflow: "auto",
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  fontWeight: 700,
                  fontSize: 16,
                  p: 2,
                  pb: 0,
                  color: "#424956",
                }}
              >
                Collection Combinations
              </Typography>
              <Box sx={{ p: 2, pt: 1 }}>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr style={{ background: "#F8F9FA" }}>
                      <th
                        style={{
                          textAlign: "left",
                          padding: "8px",
                          fontWeight: 600,
                          borderBottom: "1px solid #F3F4F6",
                          fontFamily: "Inter",
                          fontSize: "14px",
                        }}
                      >
                        Combination
                      </th>
                      <th
                        style={{
                          textAlign: "left",
                          padding: "8px",
                          fontWeight: 600,
                          borderBottom: "1px solid #F3F4F6",
                          fontFamily: "Inter",
                          fontSize: "14px",
                        }}
                      >
                        Product Count
                      </th>
                    </tr>
                  </thead>
                  {loading ? <>Loading...</> :
                    <tbody>
                      {Array.isArray(collectionCombData) && collectionCombData.length > 0 ? (
                        collectionCombData.map((comb) => (
                          <tr key={comb.id}>
                            <td
                              style={{
                                padding: "8px",
                                borderBottom: "1px solid #F3F4F6",
                                fontFamily: "Inter",
                                fontSize: "14px",
                              }}
                            >
                              {comb.combination}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                borderBottom: "1px solid #F3F4F6",
                                fontFamily: "Inter",
                                fontSize: "14px",
                              }}
                            >
                              {comb.product_count}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={2} style={{ padding: "8px", color: "#BCC1CA" }}>
                            No combinations found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  }
                </table>
              </Box>
            </Box>

            {/* Create collection Button */}
            <div style={{ textAlign: "start", marginTop: "15px" }}>
              <Button
                sx={{
                  width: "307px",
                  height: "44px",
                  backgroundColor: "#565E6D",
                  color: "#fff",
                  "&:hover": { backgroundColor: "#546e7a" },
                  borderRadius: "0px",
                }}
                onClick={handleCreateCollection}
              >
                Create collection
              </Button>
            </div>
            {/* Manual Nested Tags collection */}
            {/* {isManualCollectionSaved && (
              <Button
                sx={{
                  width: "265px",
                  height: "26px",
                  backgroundColor: "#fff",
                  color: "#000",
                  borderRadius: "0px",
                  fontWeight: 700,
                  fontFamily: "Inter",
                  fontSize: 14,
                  borderBottom: "1px solid #000",
                }}
                onClick={togglenestedTags} // Toggle nested collection visibility
              >
                Create a nested collection
              </Button>
            )} */}

            {/* Conditionally render ManualNestedCollection */}
            {/* {showNestedCollection && (
              <ManualNestedCollection
                setManualCollection={(tags) =>
                  setManualCollection(
                    tags.map((tag) => ({
                      id: tag.id,
                      product_tag: tag.product_tag,
                    }))
                  )
                }
                setManualNestedCollection={(nestedCollection) => {
                  setManualNestedCollection(nestedCollection); // Update local state
                  handleShowCollectionSection(); // Notify parent to show the collection section
                  mainCollectionId = { mainCollectionId };
                }}
              />
            )} */}
          </AccordionDetails>
        </Accordion>
      </Box>
    </Box>
  );
}
